// extracted by mini-css-extract-plugin
export var root = "sdfo";
export var rootContainer = "sAxj";
export var rootMobileOpened = "A3v7";
export var rootNavLabel = "LFEj";
export var rootNavLabelIcon = "_9lAj";
export var rootOverflowHidden = "YlXp";